export const ViewEnum = Object.freeze({
    TIMELINE: 'TIMELINE',
    DAYGRID: 'DAYGRID',
})
